import { createInstance, type i18n as I18n } from "i18next";
import { ESIGN_LANGUAGE } from "../constants/eSign";

/**
 * Dedicated i18n instance for Freyr `ESignValidation` only.
 *
 * Freyr's `t()` returns the raw key unless the host initializes i18next and
 * `FreyrComponentLibraryProvider` can call `setI18nInstance`. A separate
 * instance + `I18nextProvider` around e-sign avoids `initReactI18next` on the
 * default singleton, so Dynamic Form and the rest of gri_fe stay unchanged.
 */
export const esignI18n: I18n = createInstance();

if (!esignI18n.isInitialized) {
  void esignI18n.init({
    lng: ESIGN_LANGUAGE,
    fallbackLng: ESIGN_LANGUAGE,
    resources: { [ESIGN_LANGUAGE]: { translation: {} } },
    interpolation: { escapeValue: false },
    initImmediate: false,
  });
}
